import { useRouter } from 'next/router';

import { AUTH_ROUTE } from '@shared/v2/utils/oauth';

import { Member } from '../../types';

type UseSetOAuthStatePathOptions = {
  memberDetails: Member | null | undefined;
  oAuthState: string;
};

// Store path on every route change when user is not logged in.
// We redirect user back to this path after they log in.
export const useSetOAuthStatePath = ({
  memberDetails,
  oAuthState,
}: UseSetOAuthStatePathOptions) => {
  const { asPath } = useRouter();

  const isServer = typeof window === 'undefined';

  if (isServer || memberDetails || asPath.startsWith(AUTH_ROUTE)) {
    return;
  }

  localStorage.setItem(oAuthState, JSON.stringify(asPath));
};
